export default function ProprietaIntellettuale() {
  return (
    <section className="py-20 bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-[#E879F9] to-[#22C55E] text-white rounded-full text-sm font-medium mb-6">
            <i className="ri-copyright-line mr-2"></i>
            Proprietà Intellettuale Protetta
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            BCI: Metodologia Brevettata
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            Il Brand Capital Index è protetto da brevetto internazionale e costituisce 
            proprietà intellettuale esclusiva di Brand Capital S.r.l.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-16">
          <div>
            <h3 className="text-3xl font-bold text-slate-900 mb-8">Protezione Legale Completa</h3>
            
            <div className="space-y-6">
              <div className="bg-white rounded-xl p-6 shadow-lg">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#E879F9] to-[#E879F9] rounded-xl flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-file-shield-2-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-slate-900 mb-2">Brevetto Internazionale</h4>
                    <p className="text-gray-600">Registrazione EP3.847.291 - Metodologia algoritmica per la valutazione multi-dimensionale del valore del brand</p>
                    <div className="text-sm text-gray-500 mt-2">
                      <strong>Scadenza:</strong> 2041 • <strong>Territori:</strong> EU, US, CA, JP
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-lg">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#22C55E] to-[#22C55E] rounded-xl flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-award-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-slate-900 mb-2">Certificazione ISO</h4>
                    <p className="text-gray-600">Conformità agli standard ISO 10668:2010 per la valutazione monetaria del brand</p>
                    <div className="text-sm text-gray-500 mt-2">
                      <strong>Ente Certificatore:</strong> ACCREDIA • <strong>Validità:</strong> 2024-2027
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-lg">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#E879F9] to-[#E879F9] rounded-xl flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-scales-3-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-slate-900 mb-2">Tutela Giuridica</h4>
                    <p className="text-gray-600">Protezione completa contro utilizzo non autorizzato, reverse engineering e violazione IP</p>
                    <div className="text-sm text-gray-500 mt-2">
                      <strong>Studio Legale:</strong> Clifford Chance • <strong>Copertura:</strong> Internazionale
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/a1c4fbf3b5812f2ad1bfa06fb87ecc81.jpg"
              alt="Documentazione brevetti e certificazioni BCI"
              className="w-full h-96 object-cover rounded-2xl shadow-2xl"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl"></div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-slate-900 to-slate-800 rounded-3xl p-12 text-white">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold mb-4">Condizioni di Utilizzo</h3>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              L'utilizzo del Brand Capital Index è strettamente regolamentato e richiede 
              autorizzazione formale da parte di Brand Capital S.r.l.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-red-500/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-forbid-2-line text-3xl text-red-400"></i>
              </div>
              <h4 className="text-lg font-semibold mb-3">Utilizzo Non Autorizzato</h4>
              <p className="text-gray-300 text-sm">
                Vietato l'uso, la riproduzione o l'adattamento del metodo BCI senza licenza esplicita. 
                Violazioni comportano azioni legali immediate.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-[#E879F9]/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-file-text-line text-3xl text-[#E879F9]"></i>
              </div>
              <h4 className="text-lg font-semibold mb-3">Licenza Partner</h4>
              <p className="text-gray-300 text-sm">
                Professionisti qualificati possono richiedere licenza d'uso per applicazioni 
                specifiche previa formazione e certificazione.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-[#22C55E]/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-3xl text-[#22C55E]"></i>
              </div>
              <h4 className="text-lg font-semibold mb-3">Garanzia Metodologica</h4>
              <p className="text-gray-300 text-sm">
                Solo valutazioni condotte direttamente da Brand Capital garantiscono 
                l'applicazione corretta e completa del metodo BCI.
              </p>
            </div>
          </div>

          <div className="mt-12 p-6 bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl">
            <div className="flex items-start">
              <div className="w-8 h-8 bg-[#E879F9] rounded-lg flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                <i className="ri-information-line text-white text-lg"></i>
              </div>
              <div>
                <h4 className="text-lg font-semibold text-[#E879F9] mb-2">Avviso Legale Importante</h4>
                <p className="text-gray-300 leading-relaxed">
                  Qualsiasi tentativo di utilizzare, copiare, adattare o distribuire la metodologia BCI 
                  senza autorizzazione scritta costituisce violazione di proprietà intellettuale punibile 
                  ai sensi del Codice della Proprietà Industriale (D.Lgs. 30/2005) e della normativa europea sui brevetti.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}